import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollTarget"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/analytics/components/ScrollTarget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/StrapiHeader/Header.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageLayout.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/AdvantagesRedesign/AdvantagesCard/AdvantagesCard.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/AdvantagesRedesign/AdvantagesInstruction/AdvantagesInstruction.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageViewLogger.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/components/Advantages/Advantages.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["GamesMonth"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/components/GamesMonth/GamesMonth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Intro"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/components/Intro/Intro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchPicksBlock"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/components/SearchPicksBlock/SearchPicksBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TVBlock"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/components/TVBlock/TVBlock.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/landing_page/LandingPage.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/image-component.js");
